// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__XMCWO","content":"styles_content__ywf8Y","title":"styles_title__4jxQZ","item":"styles_item__atEvL","row":"styles_row__8BLru"};